'use client';

import { StatusBadge } from '@/components/ui/status-badge';
import { ShieldCheck } from 'lucide-react';

/**
 * CertifiedBadge - `info`-toned badge indicating a certified copy
 *
 * Used to mark documents that are certified copies (e.g., certified death certificates)
 */
export function CertifiedBadge() {
  return (
    <StatusBadge tone="info" icon={ShieldCheck} className="whitespace-nowrap">
      Certified Copy
    </StatusBadge>
  );
}
